import codes from '../assets/country.json';
import { ICountry } from '../../types';
export const countryCodes: ICountry = codes;
